import { render, staticRenderFns } from "./PostRequestButton.vue?vue&type=template&id=22345618&scoped=true&"
import script from "./PostRequestButton.vue?vue&type=script&lang=ts&"
export * from "./PostRequestButton.vue?vue&type=script&lang=ts&"
import style0 from "./PostRequestButton.vue?vue&type=style&index=0&id=22345618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22345618",
  null
  
)

export default component.exports